import {Svg} from '@modifi/ui'
import React from 'react'

export default ({...props}) => (
  <Svg width="150" height="150" viewBox="0 0 150 150" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#51545C" d="M41 28v40.023h3.741V31.746h60.517v83.507H75.524V119H109V28z" />
      <path fill="#50A0D5" d="M96 61.208L93.929 59l-4.315 4.607-2.555-2.725L85 63.078 89.616 68z" />
      <g transform="translate(30 28)">
        <g transform="translate(0 45.18)">
          <mask id="rc-1" fill="#fff">
            <path d="M0 .573h37.049v48.372H0z" />
          </mask>
          <path
            fill="#2364AF"
            d="M18.524 48.945l.195-.09c6.808-3.133 18.33-10.47 18.33-18.085V9.137l-.377-.076c-7.058-1.42-13.394-4.34-17.84-8.22l-.308-.268-.306.268c-4.446 3.88-10.782 6.8-17.84 8.22L0 9.137V30.77c0 7.616 11.522 14.951 18.33 18.086l.194.09z"
            mask="url(#rc-1)"
          />
        </g>
        <path
          fill="#78B542"
          d="M7.674 71.083l8.71 8.788 14.17-14.278-2.445-2.465-11.727 11.838-6.28-6.334z"
        />
        <path
          fill="#50A0D5"
          d="M67.01 45.354l-2.196-2.214-4.574 4.62-2.709-2.732-2.182 2.203 4.893 4.936zM67.01 57.94l-2.196-2.215-4.574 4.62-2.709-2.732-2.182 2.203 4.893 4.936zM67.01 70.456l-2.196-2.215-4.574 4.62-2.709-2.732-2.182 2.202 4.893 4.938z"
        />
        <mask id="rc-2" fill="#fff">
          <path d="M0 94.126h78.424V.03H0z" />
        </mask>
        <path
          fill="#51545C"
          d="M22 27.074h24.932v-3.138H22zM21.661 21.175h44.046v-3.137H21.661zM21.661 14.658h44.046V11.52H21.661zM22 32.973h24.932v-3.138H22zM22 38.871h24.932v-3.137H22z"
          mask="url(#rc-2)"
        />
      </g>
    </g>
  </Svg>
)
